import React, { useEffect } from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import './NouriaLayout.css';

/* Nouria's pages are light only — The Pantry Life style guide applied to health.
   The layout swaps the site's dark chrome for Nouria's own header and footer and
   lifts the dark theme off <html> while any /nouria route is mounted. */
export default function NouriaLayout() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.documentElement.classList.add('nouria-theme');
    return () => document.documentElement.classList.remove('nouria-theme');
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="nouria">
      <header className="nouria-header">
        <div className="nouria-container nouria-header-inner">
          <Link to="/nouria" className="nouria-logo" aria-label="Nouria home">
            <img src="/assets/nouria/icon.png" alt="" width="28" height="28" className="nouria-logo-icon" />
            <span className="nouria-logo-word">Nouria</span>
          </Link>
          <nav className="nouria-nav" aria-label="Nouria navigation">
            <NavLink to="/nouria" end className="nouria-nav-link">Overview</NavLink>
            <NavLink to="/nouria/support" className="nouria-nav-link">Support</NavLink>
            <NavLink to="/nouria/privacy" className="nouria-nav-link">Privacy</NavLink>
          </nav>
        </div>
      </header>

      <main className="nouria-main">
        <Outlet />
      </main>

      <footer className="nouria-footer">
        <div className="nouria-container nouria-footer-inner">
          <div className="nouria-footer-brand">
            <div className="nouria-footer-lockup">
              <img src="/assets/nouria/icon.png" alt="" width="22" height="22" className="nouria-logo-icon" />
              <span className="nouria-footer-name">Nouria</span>
            </div>
            <span className="nouria-footer-copy">
              © {new Date().getFullYear()} The Pantry Life
            </span>
            <span className="nouria-footer-copy">
              Nouria is general information, not medical advice.
            </span>
          </div>
          <nav className="nouria-footer-links" aria-label="Nouria footer navigation">
            <Link to="/nouria/support" className="nouria-footer-link">Support</Link>
            <Link to="/nouria/privacy" className="nouria-footer-link">Privacy Policy</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}
